import { useState, useEffect } from 'react';

interface CountdownTimerProps {
  endTime: string | Date;
  onExpire?: () => void;
}

export const CountdownTimer = ({ endTime, onExpire }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(endTime));

  useEffect(() => {
    const tick = () => {
      const t = getTimeLeft(endTime);
      setTimeLeft(t);
      if (t.total <= 0) onExpire?.();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endTime, onExpire]);

  if (timeLeft.total <= 0) return <span className="text-xs font-bold text-error">Expired</span>;

  return (
    <div className="flex items-center gap-1">
      {timeLeft.hours > 0 && <TimeUnit value={timeLeft.hours} label="h" />}
      <TimeUnit value={timeLeft.minutes} label="m" />
      <TimeUnit value={timeLeft.seconds} label="s" />
    </div>
  );
};

const TimeUnit = ({ value, label }: { value: number; label: string }) => (
  <div className="flex items-center gap-0.5">
    <span className="bg-gray-900 text-white text-xs font-mono font-bold px-1.5 py-0.5 rounded min-w-[26px] text-center">
      {String(value).padStart(2, '0')}
    </span>
    <span className="text-xs text-gray-500">{label}</span>
  </div>
);

function getTimeLeft(endTime: string | Date) {
  const total = Math.max(0, new Date(endTime).getTime() - Date.now());
  return {
    total,
    hours: Math.floor(total / (1000 * 60 * 60)),
    minutes: Math.floor((total % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((total % (1000 * 60)) / 1000),
  };
}
